import { initializeApp } from "firebase/app";
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

/* =========================
   FIREBASE CONFIG
========================= */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: "freshkind-56f5b",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

/* =========================
   INITIALIZE FIREBASE
========================= */
const app = initializeApp(firebaseConfig);

/* Analytics (safe on deployed HTTPS) */
const analytics = getAnalytics(app);

/* =========================
   AUTH
========================= */
export const auth = getAuth(app);

/* =========================
   GOOGLE AUTH PROVIDER
========================= */
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});

/* =========================
   FACEBOOK AUTH PROVIDER
========================= */
export const facebookProvider = new FacebookAuthProvider();

/* 🔑 REQUIRED PERMISSIONS */
facebookProvider.addScope("email");
facebookProvider.addScope("public_profile");

/* Optional UI hint */
facebookProvider.setCustomParameters({
  display: "popup",
});

/* =========================
   FIRESTORE & STORAGE
========================= */
export const db = getFirestore(app);
export const storage = getStorage(app);

/* =========================
   PHONE AUTH (RECAPTCHA)
========================= */
export const setupRecaptcha = (phoneNumber: string) => {
  const recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
    size: "invisible",
  });

  return signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier);
};
